import { FactCheck } from '@mui/icons-material';
import { Grid, Alert, lighten, AlertTitle, Button, Typography, Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { MemberUpdateModal } from './memberUpdateModal';

type MemberUpdateRequestedMessageProps = {
  callback: () => void;
  isMember: boolean;
  memberUpdateId: number;
};

export const MemberUpdateRequestedMessage = (props: MemberUpdateRequestedMessageProps) => {
  const { callback, isMember, memberUpdateId } = props;
  const { t } = useTranslation(['member']);
  const { currentUser } = useGlobals();

  const [showMemberUpdateModal, setShowMemberUpdateModal] = useState<boolean>(false);

  const handleMemberUpdate = () => {
    setShowMemberUpdateModal(false);
    callback();
  };

  return (
    <>
      <Grid item xs={12}>
        <Alert
          severity='warning'
          variant='outlined'
          sx={{ backgroundColor: lighten(Colors.ChipColors.Yellow, 0.9), '& .MuiAlert-message': { width: '1000%' } }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <Box>
              <AlertTitle>{t('member:memberDetails.updateRequestedHeader')}</AlertTitle>
              <Typography>{t('member:memberDetails.updateRequestedDescription')}</Typography>
            </Box>
            {getPermission(currentUser, PermissionEnum.MemberApprove) && !isMember && (
              <Button variant='contained' size='large' startIcon={<FactCheck />} sx={{ mt: 2 }} onClick={() => setShowMemberUpdateModal(true)}>
                {t('member:memberDetails.reviewUpdateButton')}
              </Button>
            )}
          </Box>
        </Alert>
      </Grid>
      {showMemberUpdateModal && (
        <MemberUpdateModal
          modalOpen={showMemberUpdateModal}
          memberUpdateId={memberUpdateId}
          onSave={() => handleMemberUpdate()}
          onClose={() => handleMemberUpdate()}
        />
      )}
    </>
  );
};
